import { useContext } from "react";
import { LanguageContext } from "./langugaeContext";
import TransEn from "../translations/en";
import TransEs from "../translations/es";
import TransPu from "../translations/pu";

const translationsMap = {
  Eng: TransEn,
  Es: TransEs,
  Pu: TransPu,
};

export const useTranslation = () => {
  const { language } = useContext(LanguageContext);
  return translationsMap[language] || TransEn; // Default to English
};
